import {
  Entity,
  PrimaryColumn,
  Column,
  BaseEntity,
  ManyToOne,
  JoinColumn,
} from 'typeorm'
import { ProjectDate as TProjectDateData } from '@/api/client'
import { Project } from './Project'
import { DateTime } from 'luxon'

@Entity('projectDates')
export class ProjectDate extends BaseEntity {
  /*
    ProjectDates are deleted (cascade) when the related project is deleted
  */
  @PrimaryColumn('int')
  id!: number

  @Column('varchar')
  name!: string

  @Column('varchar', { nullable: true })
  number!: string | null

  @Column({ type: 'varchar', nullable: true })
  start_date!: string | null

  @Column({ type: 'varchar', nullable: true })
  end_date!: string | null

  @Column({ type: 'varchar', nullable: true })
  rrule!: string | null

  @Column({ type: 'varchar', nullable: true })
  description!: string | null

  @Column({ type: 'varchar', nullable: true })
  location!: string | null

  @Column({ type: 'varchar', nullable: true })
  completed_date!: string | null

  @ManyToOne(() => Project, (project) => project.project_dates)
  @JoinColumn({ name: 'project_id' })
  project!: Project

  public static createFromData(
    projectDateData: TProjectDateData,
    project: Project,
  ): ProjectDate {
    const projectDate = new ProjectDate()
    projectDate.id = projectDateData.id
    projectDate.name = projectDateData.name
    projectDate.start_date = projectDateData.start_date
    projectDate.end_date = projectDateData.end_date
    projectDate.rrule = projectDateData.rrule
    projectDate.description = projectDateData.description
    projectDate.location = projectDateData.location
    projectDate.completed_date = projectDateData.completed_date
    projectDate.number = projectDateData.number
    projectDate.project = project
    return projectDate
  }

  async complete() {
    const now = DateTime.now().toISO()
    if (!this.rrule) {
      this.completed_date = now
      await this.save()
    } else {
      // TODO: flag completed in projectStore to hide on schedule
    }
  }

  async uncomplete() {
    this.completed_date = null
    await this.save()
  }
}
